<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addNode">{{ $t('add_node') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <v-select :options="nodeTypeOptions" :reduce="label => label.value" :placeholder="$t('node_type')" v-model="nodeSearchParams.node_type_id" class="md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$t('domain')" v-model="nodeSearchParams.domain" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$t('port')" v-model="nodeSearchParams.port" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$t('label')" v-model="nodeSearchParams.label" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadNodes(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="nodeDataContainer" :title="$tc('node', 2)" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-servers-tab-nav></shared-servers-tab-nav>
      </template>

      <vs-table hover-flat v-if="nodeList && nodeList.length" :data="nodeList">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('node_type')"></vs-th>
          <vs-th v-text="$t('domain')"></vs-th>
          <vs-th v-text="$t('port')"></vs-th>
          <vs-th v-text="$t('label')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.node_type_name"></vs-td>
            <vs-td v-text="tr.domain"></vs-td>
            <vs-td v-text="tr.port"></vs-td>
            <vs-td v-text="tr.label"></vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="editNode(tr.id)"></vs-button>&nbsp;
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="deleteNode(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>


      <template slot="footer">
        <paginate
          :total="pageCount"
          :itemPerPage="itemPerPage"
          :click-handler="loadNodes"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_node')" :active.sync="modals.add" size="lg">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <label class="vs-input--label" v-text="$t('node_type')"></label>
            <v-select :options="nodeTypeOptions" :reduce="label => label.value" :placeholder="$t('node_type')" v-model="nodeFormData.node_type_id" class="md:mb-0" />
            <validation-error :model-error="nodeFormErrors.node_type_id"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('port')" :placeholder="$t('port')" v-model="nodeFormData.port" class="w-full"/>
            <validation-error :model-error="nodeFormErrors.port"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('domain')" :placeholder="$t('domain')" v-model="nodeFormData.domain" class="w-full"/>
            <validation-error :model-error="nodeFormErrors.domain"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('label')" :placeholder="$t('label')" v-model="nodeFormData.label" class="w-full"/>
            <validation-error :model-error="nodeFormErrors.label"></validation-error>
          </div>
        </div>
      </div>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addNodeButton" color="primary" type="filled" @click.prevent="submitNode">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_node')" :active.sync="modals.edit" size="lg">
      <div id="nodeEditFormDataContainer" class="vs-con-loading__container">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <div class="mb-3">
              <label class="vs-input--label" v-text="$t('node_type')"></label>
              <v-select :options="nodeTypeOptions" :reduce="label => label.value" :placeholder="$t('node_type')" v-model="nodeFormData.node_type_id" class="md:mb-0" />
              <validation-error :model-error="nodeFormErrors.node_type_id"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('port')" :placeholder="$t('port')" v-model="nodeFormData.port" class="w-full"/>
              <validation-error :model-error="nodeFormErrors.port"></validation-error>
            </div>
          </div>

          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <div class="mb-3">
              <vs-input :label="$t('domain')" :placeholder="$t('domain')" v-model="nodeFormData.domain" class="w-full"/>
              <validation-error :model-error="nodeFormErrors.domain"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('label')" :placeholder="$t('label')" v-model="nodeFormData.label" class="w-full"/>
              <validation-error :model-error="nodeFormErrors.label"></validation-error>
            </div>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editNodeButton" color="primary" type="filled" @click.prevent="updateNode">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SharedServersTabNav from '@/views/Shared/Servers/TabNav'
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import Node from '@/models/Node'

export default {
  name: 'Admin.Servers.Nodes',
  mixins: [Pagination],
  components: {
    SharedServersTabNav,
    Paginate,
    Modal
  },
  data () {
    return {
      nodeList: {},
      pageCount: 0,
      nodeTypeOptions: [],
      nodeFormData: {
        node_type_id: '',
        domain: '',
        port: '',
        label: ''
      },
      itemPerPage: null,
      nodeFormErrors: [],
      nodeSearchParams: {},
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetNodeForm()
      }
    },
    'modals.edit' (val) {
      if (!val) {
        this.resetNodeForm()
      }
    }
  },
  mounted () {
    this.loadNodes(this.initialPage, null)
  },
  methods: {
    async loadNodes (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#nodeDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await Node.findAll({ ...this.nodeSearchParams, page, itemPerPage })
      this.nodeList = response.data.data
      this.pageCount = response.data.meta.pagination.last_page
      this.nodeTypeOptions = response.data.meta.options.nodeTypes
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#nodeDataContainer > .con-vs-loading')
    },
    addNode () {
      this.modals.add = true
    },
    async submitNode () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addNodeButton', scale: 0.45})

      try {
        const response = await Node.store(this.nodeFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadNodes(1, null)
        this.resetNodeForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.nodeFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addNodeButton > .con-vs-loading')
    },
    async editNode (id) {
      this.$vs.loading({container: '#nodeEditFormDataContainer'})

      try {
        this.modals.edit = true
        const response = await Node.view({ id })
        this.nodeFormData = response.data.node
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#nodeEditFormDataContainer > .con-vs-loading')
    },
    async updateNode () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editNodeButton', scale: 0.45})

      try {
        const response = await Node.update(this.nodeFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.edit = false

        this.loadNodes()
        this.resetNodeForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.nodeFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#editNodeButton > .con-vs-loading')
    },
    async deleteNode (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await Node.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadNodes(1, null)
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    resetNodeForm () {
      this.nodeFormData = {
        node_type_id: '',
        domain: '',
        port: '',
        label: ''
      }
      this.nodeFormErrors = {}
    }
  }
}
</script>

<style lang="scss">
  #addNodeButton,
  #editNodeButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
